import { render, staticRenderFns } from "./learningGuide.vue?vue&type=template&id=2874e03a&scoped=true&"
import script from "./learningGuide.vue?vue&type=script&lang=js&"
export * from "./learningGuide.vue?vue&type=script&lang=js&"
import style0 from "./learningGuide.vue?vue&type=style&index=0&id=2874e03a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2874e03a",
  null
  
)

export default component.exports